import type { RouteLocationNormalizedGeneric } from "vue-router"
const fromRoute = ref<RouteLocationNormalizedGeneric | null>(null)
const toRoute = ref<RouteLocationNormalizedGeneric | null>(null)

export default (to?: RouteLocationNormalizedGeneric, from?: RouteLocationNormalizedGeneric) => {
  if (to) toRoute.value = to
  if (from) fromRoute.value = from

  return { fromRoute, toRoute }
}
